const imgUrl = {
    //'logo' : require('./covidkayalogo.png'),
    'dohlogo' : require('./dohlogo.png'),
    //'coughing' : require('./coughing.jpg'),
    //'loginPageImage' : require('./loginPageImage.jpg'),
    //'durelogowhite' : require('./durelogowhite.png'),
    'addUser' : require('./home/lightgreen/add-user.svg'),
    'search' : require('./home/lightgreen/search.svg'),
    'alert' : require('./home/lightgreen/alert.svg'),
    'records' : require('./home/lightgreen/records.svg'),
    'referral' : require('./home/lightgreen/referral.svg'),
    'file_download' : require('./home/lightgreen/file-download.svg'),
    'file_upload' : require('./home/lightgreen/file-upload.svg'),
    'chatbot' : require('./newloginpageicons/chatbot.png'),
    'guide' : require('./newloginpageicons/guide.png'),
    'pdf' : require('./newloginpageicons/pdf.png'),
    'video_tutorial' : require('./newloginpageicons/video-tutorial.png'),
}

export default imgUrl;